import { useState } from "react";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import checkIfEnable from "../../../utils/checkIfEnable";
import ServiceIDByLabel from "../../../services/ServiceIDByLabel";

const MenuItemCardmobile = ({ icon, label, labelm, labela }) => {
  const services_list = useSelector((state) => state.refreshToken.services);
  const [showExandArrow, setShowExpandArrow] = useState(false);

  return (
    <Box
      onMouseLeave={() => setShowExpandArrow(false)}
      onMouseEnter={() => setShowExpandArrow(true)}
      sx={[
        checkIfEnable(ServiceIDByLabel, label, labelm, labela, services_list) &&
          {},
        !checkIfEnable(
          ServiceIDByLabel,
          label,
          labelm,
          labela,
          services_list,
        ) && {},
      ]}
    >
      <div className="w-full flex items-center justify-start px-padding-md pb-padding-md pt-padding-base">
        <img
          src={icon}
          alt=""
          className="w-icon-lg h-icon-lg"
        />
        <span className="ml-margin-sm text-text-primary">
          {labelm + " " + labela}
        </span>
      </div>
    </Box>
  );
};

export default MenuItemCardmobile;
